import axios from "axios";
import {
  API_BASE_PATHS,
  API_ROUTES,
  IContactInquiriesResponse,
  IContactInquiryRequest,
} from "../libs";
import { buildRequestConfig } from "./buildRequestConfig";

class ContactService {
  async submitInquiry(request: IContactInquiryRequest): Promise<void> {
    await axios.post(
      `${process.env.REACT_APP_API_HOST}/${API_BASE_PATHS.CLIENT_API}/${API_ROUTES.CONTACT_INQUIRIES}`,
      request
    );
  }

  async getInquiries(cursor?: string, limit = 50): Promise<IContactInquiriesResponse> {
    const config = await buildRequestConfig();
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_HOST}/${API_BASE_PATHS.CLIENT_API}/${API_ROUTES.CONTACT_INQUIRIES}`,
      {
        ...config,
        params: { cursor, limit },
      }
    );
    return data.data;
  }
}

export const contactService = new ContactService();
